import { ALL_CLASSES_OF_BUSINESS } from '@root/helpers/constants';
import { z } from 'zod';

export const step1Schema = z.object({
  name: z.string().min(1, { message: 'Required' }),
  team: z.array(z.union([z.number(), z.string()])),
  class_of_business: z.enum(ALL_CLASSES_OF_BUSINESS).optional(),
});

export const step2Schema = step1Schema.extend({
  copy_from_template: z.string().optional(),
  copy_from_submission: z.string().optional(),
});

export const step2SchemaRefined = step2Schema.refine((data) => data.copy_from_template ?? data.copy_from_submission);

export const step3Schema = step2Schema.extend({
  branding: z.string().optional(),
  branding_id: z.string().optional(),
});
